import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const harmonizedCodeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const hs = control.value;
    if (hs && !hs.match(/[0-9]{2,4}\.[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{1,2}/)) {
        return { invalidHarmonizedCode: true };
    }
    return null;
};

